<template>
  <el-container>
     <div class="box">
     </div>
    <!-- <img class="banner" src="../assets/img/newbanner3.jpg" /> -->
    <div class="bg-box">
      
     
      <div class="componey-list">
         <img class="banner" src="../assets/img/216.png" />
        <p>奥信汽车：</p>
        <div>支持查阅公司在售的新车、二手车、特价车相关车辆信息，对中意的车辆进行收藏、或者与销售顾问及时沟通；支持用户提交底价咨询、预约试驾、买车/卖车登记、售后服务、道路救援、验车等内容预约；支持跟踪售后服务的流程进展；支持查阅汽车相关资讯等内容；</div>
        <!-- <el-row >
          <el-col  :span="4.8">公司地址：</el-col>
          <el-col  :span="16">北京市平谷区马坊镇金河北街18号院5号楼3层303</el-col>
        </el-row> -->
         <img class="banner" src="../assets/img/512.png" />
        <p>奥信汽车经销商版：</p>
        <div>支持对用户提交底价咨询、预约试驾、买车/卖车登记、售后服务、道路救援、验车等预约内容进行处理和跟踪；各4s店分别对售后服务流程进行设置与跟踪；支持各个门店对自己门店的客户进行分别管理与维护；</div>
        <!-- <el-row >
          <el-col  :span="4.8">公司地址：</el-col>
          <el-col  :span="16">北辰科技园区（新宜白大道北侧）</el-col>
        </el-row>
        <p>北京君奥达汽车销售服务有限公司 </p>
        <div>联系电话：88915588</div>
        <el-row >
          <el-col  :span="4.8">公司地址：</el-col>
          <el-col  :span="16">北京市石景山区古城大街(特钢公司厂内)北京国际汽车贸易服务园区F区5号</el-col>
        </el-row> -->
      
      </div>

    </div>
  </el-container>
</template>

<script>
export default {
  name: "application",
  data() {
    return {};
  },
  components: {},

  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.box{
  margin: 100px;
}
.el-container {
  flex-wrap: wrap;
}
.banner {
  margin: 10px 0px 0px 0px;
 width: 50px;
 height: 50px;
  object-fit: cover;
  object-position: center top;
}

.bg-box {
  width: 100%;
  min-width: 870px;
  box-sizing: border-box;
  height: 900px;
  display: flex;
  margin: 0 15%;
  position: relative;
  .map-img {
    width: 748px;
    min-width: 714px;
    height: 607px;
    background-image:url('../assets/img/mapnew.png');
    background-size: 100% 100%;
    position: relative;
  }
  .img-compony {
    position: absolute;
    width: 33px;
    height: auto;
    left: 70%;
    top: 232px;
  }
  .map-tips {
    text-align: left;
    width: 342px;
    height: 184px;
    top: 52px;
    left: 25%;
    line-height: 24px;
    position: absolute;
    background-image: url("../assets/img/mapTips.png");
    span {
      width: 300px;
      display: inline-block;
      margin-left: 20px;
    }
    p {
      font-size: $font-size-lv3;
      margin: 10px 0;
    }
    div {
      font-size: $font-size-lv4;
      color: $font-color-black;

      width: 280px;
    }
  }
  .mark-class {
    position: absolute;
    font-size: $font-size-lv3;
    display: flex;
    align-items: center;
    bottom: 136px;
    left: 8%;
    img {
      width: 50px;
      height: 50px;
    }
  }
  .barch {
    position: absolute;
    font-size: $font-size-lv3;
    display: flex;
    align-items: center;
    bottom: 88px;
    left: 9%;
    img {
      width: 30px;
      height: 40px;
      margin-right: 10px;
    }
  }
  .componey-list {
    width: 430px;
    min-width: 258px;
    text-align: left;
    margin-left: 10%;
    p {
      font-size: $font-size-lv3;
      margin-bottom: 3px;
    }
    div {
      font-size: $font-size-lv4;
      color: $font-color-black;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/application.vue